import { render, staticRenderFns } from "./ViewAgent.vue?vue&type=template&id=082b9215"
import script from "./ViewAgent.vue?vue&type=script&lang=js"
export * from "./ViewAgent.vue?vue&type=script&lang=js"
import style0 from "./ViewAgent.vue?vue&type=style&index=0&id=082b9215&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports